import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Waves } from "lucide-react";
import { HERO_IMAGE, PHONE, PHONE_TEL, BRAND_LOGO } from "@/showroomData";

// Embeddable portal hero for the main website (drop in via iframe).
export default function Embed() {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return (
    <div className="grain relative flex h-screen w-full items-center justify-center overflow-hidden bg-[#16171c] px-6 text-center text-white">
      <div className="kenburns absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${HERO_IMAGE})` }} />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/45 to-black/80" />
      <motion.div className="relative max-w-xl" initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
        <img src={BRAND_LOGO} alt="Just Spas & Outdoors" className="mx-auto mb-4 h-14 rounded-lg bg-white px-3 py-2 object-contain" />
        <h1 className="mt-4 font-display text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl">
          Step inside your <span className="text-cyan-400">dream backyard</span>
        </h1>
        <p className="mx-auto mt-4 max-w-md text-sm text-slate-300 sm:text-base">
          Take a cinematic virtual tour of our spas, swim spas and urban pools — right from your phone.
        </p>
        <a
          href={`${origin}/`}
          target="_top"
          data-testid="embed-enter-button"
          className="group mt-7 inline-flex items-center gap-3 rounded-full bg-cyan-500 px-8 py-4 font-display text-base font-semibold tracking-tight text-black transition-transform duration-200 hover:-translate-y-0.5 hover:bg-cyan-400"
          style={{ boxShadow: "0 0 40px rgba(6,182,212,0.35)" }}
        >
          Enter the Virtual Showroom
          <ArrowRight size={18} className="transition-transform duration-200 group-hover:translate-x-1" />
        </a>
        <a href={`tel:${PHONE_TEL}`} className="mt-4 block text-sm text-slate-400">
          or call us on <span className="text-white">{PHONE}</span>
        </a>
      </motion.div>
    </div>
  );
}
